export default "ed9152c494a53afd.svg"